"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _usePaginatedConversations = require("@common/hooks/use-paginated-conversations");
var _useDebouncedValue = require("@common/hooks/use-debounced-value");
var _useInfiniteScrollSentinel = require("@common/hooks/use-infinite-scroll-sentinel");
var _conversationList = require("@common/schemas/conversation-list");
var _zod = require("zod");
var _ChatContext = require("../context/ChatContext");
var _constants = require("../constants");
var _document = require("../utils/document");
var _webApi = require("../utils/web-api");
var _errors = require("../utils/errors");
var _AuthContext = require("../context/AuthContext");
var _useDioptraFetch2 = require("../hooks/use-dioptra-fetch");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _toast = require("../utils/toast");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _PageContext = require("../context/PageContext");
var _materialSymbols = require("@design/icons/material-symbols");
var _searchInput = require("@design/ui/search-input");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _input = require("@design/ui/input");
var _backSheet = _interopRequireDefault(require("../components/ui/back-sheet"));
var _trash = _interopRequireDefault(require("@assets/trash-2.svg"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var ContentWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  gap: 8px;\n  flex: 1;\n  overflow-y: auto;\n  position: relative;\n"])));
var ScrollableListWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow-y: auto;\n  padding-right: 4px;\n"])));
var MainList = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n"])));
var MonthGroup = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n"])));
var MonthName = _styledComponents.default.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  margin-bottom: 6px;\n  margin-left: 8px;\n  color: #686766;\n"])));
var ChatList = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var ChatItem = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 8px 4px;\n  gap: 4px;\n  background: #FFFFFF;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 40px;\n  box-sizing: border-box;\n\n  &:hover {\n    background: var(--background-primary-canvas);\n    border-bottom: 2px solid #D4D3D0;\n  }\n"])));
var ChatItemBody = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  min-width: 0;\n"])));
var ChatNameWrapper = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n"])));
var ChatSnippet = _styledComponents.default.span(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 140%;\n  color: #686766;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var ChatText = _styledComponents.default.span(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  flex: 1;\n  font-size: 16px;\n  line-height: 150%;\n  letter-spacing: 0.01em;\n  color: #171715;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var ActionsWrapper = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: ", ";\n  gap: 8px;\n  align-items: center;\n"])), function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? "flex" : "none";
});
var WorkspaceTag = _styledComponents.default.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  color: #374151;\n  font-size: 11px;\n  white-space: nowrap;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var DeleteButton = _styledComponents.default.button(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  img {\n    width: 18px;\n    height: 18px;\n  }\n"])));
var RenameButton = _styledComponents.default.button(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  color: #171715;\n\n  &:hover {\n    opacity: 0.7;\n  }\n"])));
var ListFooterText = _styledComponents.default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 8px 0;\n  font-size: 13px;\n  line-height: 120%;\n  color: #686766;\n"])));
var SentinelProbe = _styledComponents.default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  height: 1px;\n"])));
var PlaceholderText = _styledComponents.default.p(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  text-align: center;\n  margin-top: 50%;\n"])));
var RetryButton = _styledComponents.default.button(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0;\n  margin-left: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--primary);\n  text-decoration: underline;\n\n  &:hover {\n    opacity: 0.7;\n  }\n"])));
var RenameDialog = function RenameDialog(_ref2) {
  var isOpen = _ref2.isOpen,
    value = _ref2.value,
    _onChange = _ref2.onChange,
    onConfirm = _ref2.onConfirm,
    onCancel = _ref2.onCancel;
  var canSubmit = value.trim().length > 0;
  function submitRename(event) {
    event.preventDefault();
    if (canSubmit) onConfirm();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: isOpen,
    onOpenChange: onCancel,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "RenameDialog",
    "data-sentry-source-file": "ChatHistoryPage.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      "aria-describedby": undefined,
      onInteractOutside: function onInteractOutside(event) {
        return event.preventDefault();
      },
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "ChatHistoryPage.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "ChatHistoryPage.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "ChatHistoryPage.tsx",
          children: "Rename chat thread"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: submitRename,
        className: "contents",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
          "data-autofocus": true,
          "aria-label": "Chat name",
          value: value,
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          onFocus: function onFocus(e) {
            return e.target.select();
          },
          placeholder: "Chat name",
          "data-sentry-element": "Input",
          "data-sentry-source-file": "ChatHistoryPage.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "ChatHistoryPage.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: onCancel,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "ChatHistoryPage.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            disabled: !canSubmit,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "ChatHistoryPage.tsx",
            children: "Save"
          })]
        })]
      })]
    })
  });
};
var MONTH_KEY_LENGTH = "YYYY-MM".length;
function monthKeyOf(createdAt) {
  return new Date(createdAt).toISOString().slice(0, MONTH_KEY_LENGTH);
}
function groupByMonth(items) {
  return items.reduce(function (grouped, item) {
    var _monthKeyOf;
    (grouped[_monthKeyOf = monthKeyOf(item.createdAt)] || (grouped[_monthKeyOf] = [])).push(item);
    return grouped;
  }, {});
}
var legacyConversationListSchema = _zod.z.array(_conversationList.ConversationListItemSchema);
var parseConversationPage = function parseConversationPage(data) {
  if (Array.isArray(data)) {
    return {
      items: legacyConversationListSchema.parse(data),
      nextOffset: null
    };
  }
  return (0, _conversationList.parseConversationListPage)(data);
};
var ChatHistoryPage = function ChatHistoryPage() {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showConfirmDialog = _useState2[0],
    setShowConfirmDialog = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    conversationToDelete = _useState4[0],
    setConversationToDelete = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    conversationToRename = _useState6[0],
    setConversationToRename = _useState6[1];
  var _useState7 = (0, _react.useState)(""),
    _useState8 = _slicedToArray(_useState7, 2),
    renameValue = _useState8[0],
    setRenameValue = _useState8[1];
  var _useState9 = (0, _react.useState)(""),
    _useState0 = _slicedToArray(_useState9, 2),
    searchQuery = _useState0[0],
    setSearchQuery = _useState0[1];
  var debouncedQuery = (0, _useDebouncedValue.useDebouncedValue)(searchQuery.trim(), _useDebouncedValue.SEARCH_DEBOUNCE_MS);
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    hoveredItemId = _useState10[0],
    setHoveredItemId = _useState10[1];
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var _useChat = (0, _ChatContext.useChat)(),
    selectedConversation = _useChat.selectedConversation,
    setSelectedConversationId = _useChat.setSelectedConversationId,
    renameConversation = _useChat.renameConversation;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    documentConversations = _useState12[0],
    setDocumentConversations = _useState12[1];
  var _usePaginatedConversa = (0, _usePaginatedConversations.usePaginatedConversations)({
      endpoint: "/api/chat/conversation",
      debouncedQuery: debouncedQuery,
      extraParams: {
        includeProjectConversations: "true",
        orderBy: "createdAt"
      },
      enabled: true,
      parsePage: parseConversationPage
    }),
    items = _usePaginatedConversa.items,
    isLoadingInitial = _usePaginatedConversa.isLoadingInitial,
    isLoadingMore = _usePaginatedConversa.isLoadingMore,
    hasMore = _usePaginatedConversa.hasMore,
    hasError = _usePaginatedConversa.hasError,
    loadMore = _usePaginatedConversa.loadMore,
    isSearchMode = _usePaginatedConversa.isSearchMode,
    reload = _usePaginatedConversa.reload;
  (0, _react.useEffect)(function () {
    var cancelled = false;
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var value, ids, resolved, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return (0, _document.fetchPropertyFromDocSettings)(_constants.DIOPTRA_CHAT_CONVERSATION_ID);
          case 1:
            value = _context.v;
            ids = (value !== null && value !== void 0 ? value : "").split(",").map(function (id) {
              return id.trim();
            }).filter(Boolean);
            _context.n = 2;
            return Promise.all(ids.map(function (id) {
              return (0, _webApi.getConversationDetails)(dioptraFetch, id).then(function (details) {
                var _details$lastMessageA, _details$project;
                return {
                  id: details.id,
                  name: details.name,
                  createdAt: details.createdAt,
                  lastMessageAt: (_details$lastMessageA = details.lastMessageAt) !== null && _details$lastMessageA !== void 0 ? _details$lastMessageA : null,
                  project: (_details$project = details.project) !== null && _details$project !== void 0 ? _details$project : null
                };
              }).catch(function (error) {
                if (error instanceof _errors.UserFacingError && error.status === 404) return null;
                sendError(error instanceof Error ? error : new Error(String(error)), {
                  component: "ChatHistoryPage",
                  action: "resolve_document_conversation",
                  conversationId: id
                });
                return null;
              });
            }));
          case 2:
            resolved = _context.v;
            if (!cancelled) {
              setDocumentConversations(resolved.filter(function (row) {
                return row !== null;
              }));
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            sendError(_t, {
              component: "ChatHistoryPage",
              action: "fetch_document_conversation_ids"
            });
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }))();
    return function () {
      cancelled = true;
    };
  }, []);
  var visibleDocumentConversations = (0, _react.useMemo)(function () {
    if (isSearchMode) return [];
    var visible = documentConversations.filter(function (conv) {
      return conv.lastMessageAt || conv.id === (selectedConversation === null || selectedConversation === void 0 ? void 0 : selectedConversation.id);
    });
    var selectedIsListed = selectedConversation !== undefined && (visible.some(function (conv) {
      return conv.id === selectedConversation.id;
    }) || items.some(function (conv) {
      return conv.id === selectedConversation.id;
    }));
    if (selectedConversation !== undefined && !selectedIsListed) {
      var _selectedConversation, _selectedConversation2;
      visible.unshift({
        id: selectedConversation.id,
        name: selectedConversation.name,
        createdAt: selectedConversation.createdAt,
        lastMessageAt: (_selectedConversation = selectedConversation.lastMessageAt) !== null && _selectedConversation !== void 0 ? _selectedConversation : null,
        project: (_selectedConversation2 = selectedConversation.project) !== null && _selectedConversation2 !== void 0 ? _selectedConversation2 : null
      });
    }
    return visible;
  }, [isSearchMode, documentConversations, selectedConversation, items]);
  var otherConversations = (0, _react.useMemo)(function () {
    if (isSearchMode) return items;
    var documentIds = new Set(documentConversations.map(function (conv) {
      return conv.id;
    }));
    return items.filter(function (conv) {
      return !documentIds.has(conv.id);
    });
  }, [isSearchMode, items, documentConversations]);
  var groupedConversations = (0, _react.useMemo)(function () {
    return groupByMonth(otherConversations);
  }, [otherConversations]);
  var hasAnyItems = visibleDocumentConversations.length > 0 || otherConversations.length > 0;
  var sentinelRef = (0, _useInfiniteScrollSentinel.useInfiniteScrollSentinel)({
    hasMore: hasMore,
    isLoadingMore: isLoadingMore,
    loadMore: loadMore
  });

  // Pin the freshly-opened (still empty) conversation to the top, then newest-first by date.
  var sortedByDateDesc = function sortedByDateDesc(items) {
    return items.slice().sort(function (a, b) {
      var aIsEmpty = !a.lastMessageAt;
      var bIsEmpty = !b.lastMessageAt;
      if (aIsEmpty !== bIsEmpty) return aIsEmpty ? -1 : 1;
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  };
  var handleSelectConversationId = function handleSelectConversationId(id) {
    setSelectedConversationId(id);
    showPage(_PageContext.PAGES.chatPage);
  };
  var handleKeyDown = function handleKeyDown(event, conversationId) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleSelectConversationId(conversationId);
    }
  };
  var handleFocus = function handleFocus(conversationId) {
    setHoveredItemId(conversationId);
  };
  var handleBlur = function handleBlur(event, conversationId) {
    // Don't clear hover if focus is moving to the delete button within the same row
    var relatedTarget = event.relatedTarget;
    if (relatedTarget && relatedTarget.closest('[data-conversation-id="' + conversationId + '"]')) {
      return;
    }
    setHoveredItemId(null);
  };
  var handleDeleteClick = function handleDeleteClick(conversationId, event) {
    event.stopPropagation();
    setConversationToDelete(conversationId);
    setShowConfirmDialog(true);
  };
  var handleDeleteConfirm = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (conversationToDelete) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            if (authHeader) {
              _context2.n = 2;
              break;
            }
            setShowConfirmDialog(false);
            setConversationToDelete(null);
            return _context2.a(2);
          case 2:
            _context2.p = 2;
            _context2.n = 3;
            return (0, _webApi.deleteConversation)(authHeader, conversationToDelete);
          case 3:
            _context2.n = 4;
            return (0, _document.removePropertyFromDocSettings)(_constants.DIOPTRA_CHAT_CONVERSATION_ID, conversationToDelete);
          case 4:
            setDocumentConversations(function (prev) {
              return prev.filter(function (conv) {
                return conv.id !== conversationToDelete;
              });
            });
            reload();
            if ((selectedConversation === null || selectedConversation === void 0 ? void 0 : selectedConversation.id) === conversationToDelete) {
              setSelectedConversationId(undefined);
            }
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            console.error("Error deleting conversation:", _t2);
            (0, _toast.toastError)("Failed to delete conversation. Please try again.");
            sendError(_t2, {
              component: "ChatHistoryPage",
              action: "delete_conversation",
              conversationId: conversationToDelete
            });
          case 6:
            _context2.p = 6;
            setShowConfirmDialog(false);
            setConversationToDelete(null);
            return _context2.f(6);
          case 7:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 5, 6, 7]]);
    }));
    return function handleDeleteConfirm() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleDeleteCancel = function handleDeleteCancel() {
    setShowConfirmDialog(false);
    setConversationToDelete(null);
  };
  var handleRenameClick = function handleRenameClick(conversationId, currentName, event) {
    event.stopPropagation();
    setConversationToRename(conversationId);
    setRenameValue(currentName);
  };
  var handleRenameConfirm = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var newName, success;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (conversationToRename) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            newName = renameValue.trim();
            if (newName) {
              _context3.n = 2;
              break;
            }
            setConversationToRename(null);
            setRenameValue("");
            return _context3.a(2);
          case 2:
            _context3.n = 3;
            return renameConversation(conversationToRename, newName);
          case 3:
            success = _context3.v;
            if (success) {
              _context3.n = 4;
              break;
            }
            // renameConversation already logs + sendError; keep the dialog open so
            // the user can retry, and surface the failure.
            (0, _toast.toastError)("Failed to rename conversation. Please try again.");
            return _context3.a(2);
          case 4:
            setDocumentConversations(function (prev) {
              return prev.map(function (conv) {
                return conv.id === conversationToRename ? _objectSpread(_objectSpread({}, conv), {}, {
                  name: newName
                }) : conv;
              });
            });
            reload();
            setConversationToRename(null);
            setRenameValue("");
          case 5:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleRenameConfirm() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleRenameCancel = function handleRenameCancel() {
    setConversationToRename(null);
    setRenameValue("");
  };
  var renderConversationItem = function renderConversationItem(item) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatItem, {
      tabIndex: 0,
      role: "button",
      "aria-label": "Select conversation: ".concat(item.name),
      "data-conversation-id": item.id,
      onClick: function onClick() {
        return handleSelectConversationId(item.id);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, item.id);
      },
      onMouseEnter: function onMouseEnter() {
        return setHoveredItemId(item.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredItemId(null);
      },
      onFocus: function onFocus() {
        return handleFocus(item.id);
      },
      onBlur: function onBlur(e) {
        return handleBlur(e, item.id);
      },
      "data-sentry-element": "ChatItem",
      "data-sentry-component": "renderConversationItem",
      "data-sentry-source-file": "ChatHistoryPage.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ChatItemBody, {
        "data-sentry-element": "ChatItemBody",
        "data-sentry-source-file": "ChatHistoryPage.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ChatNameWrapper, {
          "data-sentry-element": "ChatNameWrapper",
          "data-sentry-source-file": "ChatHistoryPage.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChatText, {
            "data-sentry-element": "ChatText",
            "data-sentry-source-file": "ChatHistoryPage.tsx",
            children: item.name
          }), item.project && /*#__PURE__*/(0, _jsxRuntime.jsxs)(WorkspaceTag, {
            title: item.project.name,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeployedCodeIcon, {
              width: 10,
              height: 10
            }), item.project.name]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ActionsWrapper, {
            isVisible: hoveredItemId === item.id,
            "data-sentry-element": "ActionsWrapper",
            "data-sentry-source-file": "ChatHistoryPage.tsx",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RenameButton, {
              title: "Rename conversation",
              onClick: function onClick(e) {
                return handleRenameClick(item.id, item.name, e);
              },
              "data-sentry-element": "RenameButton",
              "data-sentry-source-file": "ChatHistoryPage.tsx",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
                width: 18,
                height: 18,
                "data-sentry-element": "EditIcon",
                "data-sentry-source-file": "ChatHistoryPage.tsx"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DeleteButton, {
              title: "Delete conversation",
              onClick: function onClick(e) {
                return handleDeleteClick(item.id, e);
              },
              "data-sentry-element": "DeleteButton",
              "data-sentry-source-file": "ChatHistoryPage.tsx",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _trash.default,
                alt: "Delete"
              })
            })]
          })]
        }), item.snippet && /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatSnippet, {
          children: item.snippet
        })]
      })
    }, item.id);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_backSheet.default, {
      title: "Chat history",
      backLabel: "Back to chat",
      onBack: function onBack() {
        return showPage(_PageContext.PAGES.chatPage);
      },
      className: "data-[side=right]:w-full data-[side=right]:max-w-none data-[side=right]:sm:max-w-none",
      "data-sentry-element": "BackSheet",
      "data-sentry-source-file": "ChatHistoryPage.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchInput.SearchInput, {
        className: "h-11",
        placeholder: "Search chats\u2026",
        value: searchQuery,
        onValueChange: setSearchQuery,
        "data-sentry-element": "SearchInput",
        "data-sentry-source-file": "ChatHistoryPage.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentWrapper, {
        "data-sentry-element": "ContentWrapper",
        "data-sentry-source-file": "ChatHistoryPage.tsx",
        children: isLoadingInitial ? /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceholderText, {
          children: "Loading conversations\u2026"
        }) : hasError ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaceholderText, {
          children: ["Failed to load conversations.", /*#__PURE__*/(0, _jsxRuntime.jsx)(RetryButton, {
            onClick: reload,
            children: "Retry"
          })]
        }) : hasAnyItems ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollableListWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(MainList, {
            children: [visibleDocumentConversations.length ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(MonthGroup, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MonthName, {
                children: "This document"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatList, {
                children: sortedByDateDesc(visibleDocumentConversations).map(renderConversationItem)
              })]
            }) : null, Object.keys(groupedConversations).sort(function (a, b) {
              return b.localeCompare(a);
            }).map(function (key) {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MonthGroup, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(MonthName, {
                  children: [(0, _dayjs.default)(key).format("MMMM"), " ", (0, _dayjs.default)(key).year() !== new Date().getFullYear() ? (0, _dayjs.default)(key).year() : null]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatList, {
                  children: sortedByDateDesc(groupedConversations[key]).map(renderConversationItem)
                })]
              }, key);
            }), hasMore && /*#__PURE__*/(0, _jsxRuntime.jsx)(SentinelProbe, {
              ref: sentinelRef
            }), isLoadingMore && /*#__PURE__*/(0, _jsxRuntime.jsx)(ListFooterText, {
              children: "Loading more\u2026"
            }), !hasMore && /*#__PURE__*/(0, _jsxRuntime.jsx)(ListFooterText, {
              children: "End of list"
            })]
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceholderText, {
          children: "Start your first conversation"
        })
      })]
    }), showConfirmDialog && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Delete chat thread",
      message: "Are you sure you want to delete this chat thread?",
      confirmLabel: "Delete",
      onConfirm: handleDeleteConfirm,
      onCancel: handleDeleteCancel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(RenameDialog, {
      isOpen: conversationToRename !== null,
      value: renameValue,
      onChange: setRenameValue,
      onConfirm: handleRenameConfirm,
      onCancel: handleRenameCancel,
      "data-sentry-element": "RenameDialog",
      "data-sentry-source-file": "ChatHistoryPage.tsx"
    })]
  });
};
var _default = exports.default = ChatHistoryPage;